/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2185
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.WorkspaceDB = undefined
var r = require(/* 93 */"tslib")
var i = require(/* 134 */"inversify")
var o = function () {
  function e() {
    this.db = new Map()
  }
  e.prototype.add = function (e) {
    this.db.set(e.id, e)
  }
  e.prototype.remove = function (e) {
    return this.db.delete(e.id)
  }
  e.prototype.get = function (e) {
    return this.db.get(e)
  }
  return e = (0, r.__decorate)([(0, i.injectable)()], e)
}()
exports.WorkspaceDB = o
